import React from 'react';

import { AlertDialogTitle } from '@/ux-common/components/alert-dialog/alert-dialog';
import { Header, HeaderIcon, HeaderTitle } from '@/ux-common/components/header/header';
import { Typography } from '@/ux-common/components/typography/typography';

interface AlertDialogTitleHeaderProps {
  /** Header glyph (e.g. a critical Icon for a destructive confirm). */
  icon?: React.ReactNode;
  title: React.ReactNode;
}

/**
 * The standard registry AlertDialog header: optional leading icon and the aria
 * title styled as a section header. Deliberately no close X — an AlertDialog
 * has exactly two exits, both in the footer.
 */
export const AlertDialogTitleHeader = ({ icon, title }: AlertDialogTitleHeaderProps) => (
  <Header data-component="AlertDialogTitleHeader">
    {icon ? <HeaderIcon>{icon}</HeaderIcon> : null}
    <HeaderTitle>
      <AlertDialogTitle asChild>
        <Typography as="h2" className="text-header-section">
          {title}
        </Typography>
      </AlertDialogTitle>
    </HeaderTitle>
  </Header>
);
